/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, errorResponse, prepareResponseData } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";

// css
import "../students/Students.css";

// api
import feeApi from "../../api/Fees";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import { Toast } from "primereact/toast";
import FullPageLoader from "../../components/loader/FullPageLoader";
import TableLoading from "../../components/skeleton/TableLoading";
import { FaPlus } from "react-icons/fa";
import FeeWrapper from "../../components/appWrapper/FeeWrapper";
import FeesTable from "../../components/tables/primeTable/fees/FeesTable";

const Fees = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [fees, setFees] = useState([]);
  const [feeModalVisibility, setFeeModalVisibility] = useState(false);
  const [selectedFeeDetail, setSelectedFeeDetail] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [modalType, setModalType] = useState("update");
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    // fetch fee
    try {
      listFees();

      if (!empty(location) && !empty(location.state)) {
        const paramState = !empty(location.state) ? location.state : {};
        let itemAdded = !empty(paramState.itemAdded)
          ? paramState.itemAdded
          : false;
        let itemUpdated = !empty(paramState.itemUpdated)
          ? paramState.itemUpdated
          : false;
        if (
          itemAdded === true ||
          itemUpdated === true 
        ) {
          const actionType = itemAdded
            ? "added"
            : itemUpdated
            ? "updated"
            : "";
          paramState.itemAdded = false;
          paramState.itemUpdated = false;
          responseDialog(
            "success",
            "Success",
            `Fee ${actionType} successfully!`
          );
          if (!empty(location) && !empty(location.state)) {
            navigate(null, {
              replace: true,
              state: {
                itemAdded: false,
                itemUpdated: false,
              },
            });
          }
        }
      }
    } catch (error) {
      responseDialog(
        "error",
        "Something went wrong",
        "Failed to load fee. Please try again later."
      );
    }
  }, [ user?._id, rows, first, searchValue ]);

  // function to get all fees
  const listFees = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const page = first / rows;
      const response = await feeApi.getFees(page, rows, searchValue);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setFees([]);
      } else {
        setFees(response_data.response);
        setTotalRecords(!empty(response_data.count) ? response_data.count : 0);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // delete fee
  const deleteFee = async () => {
    try {
      if (feeModalVisibility) setFeeModalVisibility(false);
      if (!isActionLoading) setIsActionLoading(true);
      const feeId =
        !empty(selectedFeeDetail) &&
        !empty(selectedFeeDetail._id)
          ? selectedFeeDetail._id
          : "";
      const response = await feeApi.deleteFee(feeId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        const error_response =
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to delete fee";
        return responseDialog("error", "Something went wrong", error_response);
      }

      responseDialog(
        "success",
        "Success",
        `Fee, ${
          !empty(selectedFeeDetail.title)
            ? selectedFeeDetail.title
            : ""
        }, was deleted successfully!`
      );
      return listFees();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActionLoading(false);
    }
  };

  //function to hide confirm modal
  const hideFeeModal = () => {
    setFeeModalVisibility(false);
  };

  //go to update fee page
  const gotToUpdateFees = (data) => {
    const feeId = !empty(data) && !empty(data._id) ? data._id : "";
    navigate(`/fee/${feeId}/update`);
  };

  // delete fee
  const showDeleteFeesModal = (data) => {
    setModalType("delete");
    setSelectedFeeDetail(data);
    setFeeModalVisibility(true);
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      setSearchValue(event.target.value);
      setFirst(0);
    }
  };

  const onSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const feeModalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideFeeModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={() => deleteFee()
        }
      />
    </div>
  );

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <>
      <FeeWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Fee"
              link="/fees/add"
              title="Fees"
              icon={<FaPlus />}
              iconMarginRight={5}
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <FeesTable
                fees={fees}
                goToUpdateFeeScreen={gotToUpdateFees}
                goToDeleteFeeScreen={showDeleteFeesModal}
                onPageChange={onPageChange}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={search}
                onKeyDown={onKeyDown}
                onSearchChange={onSearchChange}
              />
            ) : (
              <TableLoading rows={20} cols={3} header={false} />
            )}
            {/* table end  */}
          </div>
        </main>
        {isActionLoading && <FullPageLoader visible={isActionLoading} />}
      </FeeWrapper>

      <Dialog
        visible={feeModalVisibility}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={feeModalFooter}
        onHide={hideFeeModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          {
            <span>
              Are you sure you want to{" "}
              {modalType === "update" ? (
                !empty(selectedFeeDetail) &&
                !empty(selectedFeeDetail.active) &&
                selectedFeeDetail.active ? (
                  <span style={{ color: "red" }}>
                    <strong>disable</strong>
                  </span>
                ) : (
                  <span style={{ color: "green" }}>
                    <strong>enable</strong>
                  </span>
                )
              ) : (
                <span style={{ color: "red" }}>
                  <strong>delete</strong>
                </span>
              )}{" "}
              the selected fee -{" "}
              <strong>
                {!empty(selectedFeeDetail) &&
                !empty(selectedFeeDetail.title)
                  ? selectedFeeDetail.title
                  : ""}
              </strong>
              {selectedFeeDetail && (
                <b>
                  {!empty(selectedFeeDetail.name)
                    ? selectedFeeDetail.name
                    : ""}
                </b>
              )}
              ?
            </span>
          }
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default Fees;
